module.exports = __webpack_public_path__ + "static/media/Energy.dde3c4b1.jpg";